<section *ngIf="{
  processingSubmit: processingSubmit$ | async,
  originUrl: originUrl
  } as headerContext" class="page-heading">

  <a [ngClass]="{'hidden': headerContext.processingSubmit}" (click)="goBack()" class="close-button" mat-icon-button
    type="button">
    <mat-icon class="notranslate">close</mat-icon>
  </a>
  <h1>Apply for Covercy {{ isGpSide ? 'CRE' : 'Investors' }} Banking</h1>
  <h2 class="page-sub-header">
    Add as much relevant information as possible to your application.
    You can always save it as draft, if you would like take a break and proceed later.
    Once you send your application it will be saved under Applications on the Bank Accounts page.
    You will be able to upload all the necessary documents from there.
  </h2>
</section>

<ng-template #loadingPage>
  <terra-loader class="page-loader" />
</ng-template>

<ng-container *ngIf="(dataLoaded$ | async) else loadingPage">
  <form *ngIf="{
    isSubmitAttempt: isSubmitAttempt$ | async,
    isGeneralServerError: isGeneralServerError$ | async,
    hasServerErrorMessage: hasServerErrorMessage$ | async,
    processingSubmit: processingSubmit$ | async    ,
    applicationLevel:applicationLevel$ | async
  } as formContext" [formGroup]="pageForm" id="applicationForm">
  
    <terra-loader *ngIf="formContext.processingSubmit" class="submit-loader" />

    <div [hidden]="formContext.processingSubmit" class="cov-form">
      <!-- General -->
      <section class="form-section">
        <h3 class="section-title">Business Details</h3>
        <div class="form-fields">

          <!-- Holding  -->
          <div class="terra-form-field-wrapper large-field"
            *ngIf="currentUnitApplicationParentType == unitApplicationParentType.Holding">
            <label class="text-input-label" for="ddlHolding">Asset/Fund</label>
            <ng-container
              *ngIf="isPreselectedHolding$ | async as isPreselectedHolding; then selectedHolding; else chooseHolding">
            </ng-container>
            <ng-template #chooseHolding>
              <mat-form-field
                *ngIf="{applicationPageUrl: selectedHoldingApplicationPageUrl$ | async } as holdingMessageContext"
                appearance="outline">
                <mat-select formControlName="holdingId" id="ddlHolding" panelClass="holdings-select-panel"
                  placeholder="Select" [hideSingleSelectionIndicator]="true">
                  <mat-option>Select</mat-option>

                  <mat-option *ngFor="let holding of selectableHoldings$ | async; trackBy: holdingTrackByFn"
                    [value]="holding.id" class="lo_sensitive">
                    {{ holding.name }}
                  </mat-option>

                  <mat-divider />

                  <mat-option *ngFor="let holding of disabledHoldings$ | async; trackBy: holdingTrackByFn"
                    [value]="holding.id">
                    <span class="holding-with-application-option lo_sensitive">{{ holding.name }}</span>
                  </mat-option>
                </mat-select>

                <mat-error *ngIf="pageForm.get('holdingId').hasError('required')">
                  Required
                </mat-error>
                <mat-error *ngIf="pageForm.get('holdingId').hasError('notAllowed')">
                  <span>This asset/fund already has an ongoing application! You can see the current status of the
                    application
                    <a [routerLink]="holdingMessageContext.applicationPageUrl" class="link">here</a>.</span>
                </mat-error>

              </mat-form-field>
            </ng-template>

            <ng-template #selectedHolding>
              <mat-form-field appearance="outline" class="preselected-holding">
                <input disabled readonly class="preselected-holding lo_sensitive" id="txtPreselectedHolding" matInput
                  value="{{(preselectedHolding$ | async)?.name ?? ''}}" />
              </mat-form-field>
            </ng-template>
          </div>

          <!-- Organization Single -->
          <div class="terra-form-field-wrapper large-field"
            *ngIf="currentUnitApplicationParentType == unitApplicationParentType.Organization">
            <label class="text-input-label" for="txtOrganizationName">Organization Name</label>
            <ng-container>
              <mat-form-field appearance="outline">
                <input trim matInput id="txtOrganizationName" class="lo_sensitive" readonly
                  [value]="(organizationName$ | async)">

                <!-- <mat-error *ngIf="pageForm.get('holdingId').hasError('required')">
                  Required
                </mat-error>
                <mat-error *ngIf="pageForm.get('holdingId').hasError('notAllowed')">
                  <span>This asset/fund already has an ongoing application! You can see the current status of the
                    application
                    <a [routerLink]="holdingMessageContext.applicationPageUrl" class="link">here</a>.</span>
                </mat-error> -->

              </mat-form-field>
            </ng-container>
          </div>

          <!-- Business Name -->
          <div class="terra-form-field-wrapper large-field">
            <label class="text-input-label" for="txtBusinessName">Name of Business
              <mat-icon matTooltip="The legal name of the business." matTooltipClass="terra-tooltip-compact"
                matTooltipPosition="above">help
              </mat-icon>
            </label>
            <mat-form-field appearance="outline">
              <input trim autocomplete="business-name" class="lo_sensitive" formControlName="name" id="txtBusinessName"
                matInput placeholder="e.g ABC Group LLC" />
              <mat-error *ngIf="pageForm.get('name').hasError('required')">
                Required
              </mat-error>
              <mat-error *ngIf="pageForm.get('name').getError('maxlength') as error">
                Please enter up to {{ error.requiredLength }} characters
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Doing business as (DBA) -->
          <div class="terra-form-field-wrapper large-field">
            <label class="text-input-label" for="txtDba">Doing business as
              <mat-icon
                matTooltip="Can be the same as the legal name. It is only different when the name under which you operate your business differs from its legal, registered name."
                matTooltipClass="terra-tooltip-compact" matTooltipPosition="above">help
              </mat-icon>
            </label>
            <mat-form-field appearance="outline">
              <input trim class="lo_sensitive" formControlName="dba" id="txtDba" matInput placeholder="e.g. ABC" />
              <mat-error *ngIf="pageForm.get('dba').hasError('required')">
                Required
              </mat-error>
              <mat-error *ngIf="pageForm.get('dba').getError('maxlength') as error">
                Please enter up to {{ error.requiredLength }} characters
              </mat-error>
            </mat-form-field>
          </div>

          <!-- bank account name -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="txtAccountName">Bank account name
              <mat-icon
                matTooltip="How would you want to call this account, it could be a holding’s name if you create an account for each investment of a more general name."
                matTooltipClass="terra-tooltip-compact" matTooltipPosition="above">help
              </mat-icon>
            </label>
            <mat-form-field appearance="outline">
              <input trim class="lo_sensitive" formControlName="bankAccountName" id="txtAccountName" matInput
                placeholder="e.g. ABC" />
              <mat-error *ngIf="pageForm.get('bankAccountName').hasError('required')">Required</mat-error>
              <mat-error *ngIf="pageForm.get('bankAccountName').getError('maxlength') as error">Please enter up to
                {{ error.requiredLength }} characters
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Business EIN -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="txtEin">Business EIN</label>
            <mat-form-field appearance="outline">
              <input trim class="lo_sensitive" formControlName="ein" id="txtEin" matInput placeholder="e.g 123456789"
                (change)="einChanged()" />
              <mat-error *ngIf="pageForm.get('ein').hasError('required')">Required</mat-error>
              <mat-error *ngIf="pageForm.get('ein').hasError('pattern')">Please enter a valid EIN</mat-error>
            </mat-form-field>
          </div>

          <!--Entity type -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="ddlEntityType">Entity</label>
            <mat-form-field appearance="outline">
              <mat-select formControlName="entityType" id="ddlEntityType" placeholder="Select"
                [hideSingleSelectionIndicator]="true">
                <mat-option *ngFor="let entityType of allEntityTypes" [value]="entityType.value">{{ entityType.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="pageForm.get('entityType').hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>

          <!-- Business Vertical -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="ddBusinessVertical">Business Vertical</label>
            <mat-form-field appearance="outline">
              <mat-select formControlName="businessVertical" id="ddBusinessVertical" placeholder="Select"
                [hideSingleSelectionIndicator]="true">
                <mat-option> Select</mat-option>
                <ng-container *ngFor="let businessVertical of allBusinessVertical">
                  <ng-container
                    *ngIf="(businessVertical | enumString:UnitBusinessVertical).length > 30; else withoutTooltip">
                    <mat-option [matTooltip]="(businessVertical | enumString:UnitBusinessVertical)"
                      matTooltipClass="terra-tooltip-compact" matTooltipPosition="left" [value]="businessVertical">
                      {{ businessVertical | enumString:UnitBusinessVertical }}
                    </mat-option>
                  </ng-container>
                  <ng-template #withoutTooltip>
                    <mat-option [value]="businessVertical">
                      {{ businessVertical | enumString:UnitBusinessVertical }}
                    </mat-option>
                  </ng-template>
                </ng-container>
              </mat-select>
              <mat-error *ngIf="pageForm.get('businessContact.website').hasError('required')">
                Required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- State of Incorporation -->
          <div class="terra-form-field-wrapper state-field">
            <label class="text-input-label" for="ddlStateOfIncorporation">State of Incorporation</label>
            <mat-form-field appearance="outline">
              <mat-select formControlName="stateOfIncorporation" id="ddlStateOfIncorporation" placeholder="Select"
                [hideSingleSelectionIndicator]="true">
                <mat-option> Select</mat-option>
                <mat-option *ngFor="let stateOption of allStates" [value]="stateOption.name"> {{ stateOption.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="pageForm.get('stateOfIncorporation').hasError('required')"> Required</mat-error>
            </mat-form-field>
          </div>

          <!-- Year of Incorporation -->
          <div class="terra-form-field-wrapper state-field">
            <terra-date-picker-year [control]="pageForm.controls['yearOfIncorporation']" label="Year of Incorporation" />
          </div>

          <section class="flex flex-wrap" formGroupName="businessContact">

            <!-- Phone number -->
            <terra-phone *ngIf="pageForm" class="terra-form-field-wrapper small-field" formControlName="phone">
              <label class="text-input-label">Phone</label>
              <mat-error *ngIf="pageForm.get('businessContact.phone').hasError('required')">Required</mat-error>
              <mat-error *ngIf="pageForm.get('businessContact.phone').hasError('phone')">Invalid phone
                number</mat-error>
            </terra-phone>

            <!-- Website -->
            <div class="terra-form-field-wrapper small-field website-section">
              <label class="text-input-label" for="txtWebsite">Website</label>
              <mat-form-field appearance="outline">
                <input trim class="lo_sensitive" formControlName="website" id="txtWebsite" matInput
                  placeholder="e.g www.abc.com" />
                <mat-error *ngIf="pageForm.get('businessContact.website').hasError('required')">
                  Required
                </mat-error>
                <mat-error *ngIf="pageForm.get('businessContact.website').hasError('pattern')">
                  Please enter a valid Website
                </mat-error>
              </mat-form-field>
              <mat-checkbox color="primary" formControlName="notHaveWebsite"
                (change)="webSiteCheckbox($event.checked)">My
                business does not have a website
              </mat-checkbox>
            </div>
          </section>
        </div>
      </section>

      <!-- Address -->
      <section class="form-section inner-form-section">
        <h3 class="section-title">Business Address</h3>
        <terra-address-form [externalForm]="pageForm" [formSettings]="addressFormSettings"
          [locationDetailsResponse]="originalBusinessAddress$ | async" [lockUsaCountry]="true"
          class="form-fields address-form" partialFormName="address" street2Label="Second line of address"
          streetLabel="Street address" />
      </section>

      <!-- Contact -->
      <section class="form-section inner-form-section" formGroupName="contact">
        <h3 class="section-title">Contact</h3>
        <div class="form-fields">

          <!-- First name -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="txtFirstName">First Name</label>
            <mat-form-field appearance="outline">
              <input trim class="lo_sensitive" formControlName="firstName" id="txtFirstName" matInput
                placeholder="e.g John" />
              <mat-error *ngIf="pageForm.get('contact.firstName').hasError('required')">
                Required
              </mat-error>
              <mat-error *ngIf="pageForm.get('contact.firstName').getError('maxlength') as error">
                Please enter up to {{ error.requiredLength }} characters
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Last name -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="txtLastName">Last Name</label>
            <mat-form-field appearance="outline">
              <input trim class="lo_sensitive" formControlName="lastName" id="txtLastName" matInput
                placeholder="e.g Smith" />
              <mat-error *ngIf="pageForm.get('contact.lastName').hasError('required')">
                Required
              </mat-error>
              <mat-error *ngIf="pageForm.get('contact.lastName').getError('maxlength') as error">
                Please enter up to {{ error.requiredLength }} characters
              </mat-error>
            </mat-form-field>
          </div>

          <!-- email -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="txtEmail">Email</label>
            <mat-form-field appearance="outline">
              <input trim class="lo_sensitive" formControlName="email" id="txtEmail" matInput
                placeholder="e.g john@gmail.com" />
              <mat-error *ngIf="pageForm.get('contact.email').hasError('required')">
                Required
              </mat-error>
              <mat-error *ngIf="pageForm.get('contact.email').hasError('email')">
                Please enter a valid email address
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Phone number -->
          <terra-phone class="terra-form-field-wrapper small-field" formControlName="phone">
            <label class="text-input-label flex flex-column"><span>Mobile Number</span>
              <div class="font-bold white-space-normal flex flex-column"><span>Please provide a mobile number you can
                  access, </span><span>as it will be used to send SMS one-time codes for approving banking transactions
                  on your account.</span></div>
            </label>
            <mat-error *ngIf="pageForm.get('contact.phone').hasError('required')">Required</mat-error>
            <mat-error *ngIf="pageForm.get('contact.phone').hasError('phone')">Invalid phone number</mat-error>
          </terra-phone>
        </div>
      </section>

      <!-- Officer -->
      <section class="form-section" formGroupName="officer">
        <h3 class="section-title">Officer Details</h3>
        <mat-checkbox class="spacing" color="primary" formControlName="sameAsContact" (change)="sameAsContactChanged()">
          Same as contact information.
        </mat-checkbox>
        <div class="form-fields">

          <!-- First name -->
          <div class="terra-form-field-wrapper large-field">
            <label class="text-input-label" for="txtOfficerFirstName">First Name</label>
            <mat-form-field appearance="outline">
              <input trim class="lo_sensitive" formControlName="firstName" id="txtOfficerFirstName" matInput
                placeholder="e.g John" />
              <mat-error *ngIf="pageForm.get('officer.firstName').hasError('required')">
                Required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Last name -->
          <div class="terra-form-field-wrapper large-field">
            <label class="text-input-label" for="txtOfficerLastName">Last Name</label>
            <mat-form-field appearance="outline">
              <input trim class="lo_sensitive" formControlName="lastName" id="txtOfficerLastName" matInput
                placeholder="e.g Smith" />
              <mat-error *ngIf="pageForm.get('officer.lastName').hasError('required')">
                Required
              </mat-error>
            </mat-form-field>
          </div>

          <!--Title (CEO, COO, CFO or President)-->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="ddlOfficerTitle">Title</label>
            <mat-form-field appearance="outline">
              <mat-select formControlName="title" id="ddlOfficerTitle" placeholder="Select"
                [hideSingleSelectionIndicator]="true">
                <mat-option *ngFor="let officerTitle of allOfficerTitles" [value]="officerTitle.value">
                  {{ officerTitle.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="pageForm.get('officer.title').hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>

          <!-- Date of birth -->
          <div class="terra-form-field-wrapper">
            <terra-custom-utc-date-picker id="txtOfficerDob" formControlName="dateOfBirth" label="Date of Birth"
              [minDate]="MIN_DATE" [maxDate]="today"
              [requiredError]="pageForm.get('officer.dateOfBirth').hasError('required')"
              [touched]="pageForm.get('officer.dateOfBirth').touched"
              [minError]="pageForm.get('officer.dateOfBirth').hasError('minDate')"
              [maxError]="pageForm.get('officer.dateOfBirth').hasError('maxDate')"
              minErrorTxt="Please enter a valid date" maxErrorTxt="Please enter a valid date" startAt="1980-01-01"
              startView="multi-year" />
          </div>

          <!-- Phone number -->
          <terra-phone class="terra-form-field-wrapper small-field" formControlName="phone">
            <label class="text-input-label">Phone</label>
            <mat-error *ngIf="pageForm.get('officer.phone').hasError('required')">Required</mat-error>
            <mat-error *ngIf="pageForm.get('officer.phone').hasError('phone')">Invalid phone number</mat-error>
          </terra-phone>

          <!-- email -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="txtOfficerEmail">Email</label>
            <mat-form-field appearance="outline">
              <input trim class="lo_sensitive" formControlName="email" id="txtOfficerEmail" matInput  placeholder="e.g john@gmail.com" />
              <mat-error *ngIf="pageForm.get('officer.email').hasError('required')">
                Required
              </mat-error>
              <mat-error *ngIf="pageForm.get('officer.email').hasError('email')">
                Please enter a valid email address
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Nationality Country -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="ddNationality">Nationality</label>
            <mat-form-field appearance="outline" class="nationality-form-field" id="ddNationality">
              <terra-country-input formControlName="nationality" placeholder="Select nationality" />
              <mat-error *ngIf="pageForm.get('officer.nationality').hasError('required')">
                Required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="more-details-income terra-form-field-wrapper" *ngIf="!isUnitedStateNationality(officerGroup)">
            <!-- Occupation -->
            <div class="small-field">
              <label class="text-input-label" for="ddOccupation">Occupation</label>
              <mat-form-field appearance="outline" class="nationality-form-field" id="ddOccupation">
                <mat-select formControlName="occupation" placeholder="Select" [hideSingleSelectionIndicator]="true">
                  <mat-option>Select</mat-option>
                  <mat-option *ngFor="let item of allOccupation" [value]="item"> {{ item | enumString:UnitOccupation }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="pageForm.get('officer.occupation').hasError('required')">
                  Required
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Annual Income -->
            <div class="">
              <label class="text-input-label" for="ddAnnualIncome">Annual Income</label>
              <mat-form-field appearance="outline" class="nationality-form-field" id="ddAnnualIncome">
                <mat-select formControlName="annualIncome" placeholder="Select" [hideSingleSelectionIndicator]="true">
                  <mat-option>Select</mat-option>
                  <mat-option *ngFor="let item of allRevenue" [value]="item"> {{ item | enumString:UnitRevenue }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="pageForm.get('officer.annualIncome').hasError('required')">
                  Required
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Primary Source of Income -->
            <div class="small-field">
              <label class="text-input-label" for="ddSourceOfIncome">Primary Source of Income</label>
              <mat-form-field appearance="outline" class="nationality-form-field" id="ddSourceOfIncome">
                <mat-select formControlName="sourceOfIncome" placeholder="Select" [hideSingleSelectionIndicator]="true">
                  <mat-option>Select</mat-option>
                  <mat-option *ngFor="let item of allSourceOfIncome" [value]="item"> {{
                    item |
                    enumString:UnitSourceOfIncome
                    }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="pageForm.get('officer.sourceOfIncome').hasError('required')">
                  Required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <label class="identification-number">Identification Number:</label>
          <div class="identification-number-form">
            <mat-radio-group aria-labelledby="Identification number"
              class="radio-buttons-group radio-group-new-primary-color" formControlName="ssnOrPassport">
              <mat-radio-button [disabled]="disableSsnRadio(pageForm.get('officer.nationality'))"
                [value]="SsnOrPassport.SSN" class="ssn-radio-button">
                SSN
              </mat-radio-button>
              <mat-radio-button [disabled]="disablePassportRadio(pageForm.get('officer.nationality'))"
                [value]="SsnOrPassport.Passport" class="passport-radio-button"
                [matTooltipDisabled]="!disablePassportRadio(pageForm.get('officer.nationality'))"
                matTooltipClass="team-tooltip" matTooltipPosition="right"
                matTooltip="{{generateUsCitizenshipTooltipMessage()}}">
                Passport Number
              </mat-radio-button>
            </mat-radio-group>

            <!-- SSN -->
            <mat-form-field *ngIf="pageForm.get('officer.ssnOrPassport').value === SsnOrPassport.SSN"
              appearance="outline" class="ssn-form-field">
              <input trim class="lo_sensitive" formControlName="ssn" id="txtSsn" matInput placeholder="e.g 123456789" />
              <mat-error *ngIf="pageForm.get('officer.ssn').hasError('required')">
                Required
              </mat-error>
              <mat-error *ngIf="pageForm.get('officer.ssn').hasError('pattern')">
                Please enter a valid social security number (SSN)
              </mat-error>
            </mat-form-field>

            <a href="https://help.covercy.com/why-is-social-security-number-ssn-or-equivalent-required" target="_blank"
              *ngIf="pageForm.get('officer.ssnOrPassport').value === SsnOrPassport.SSN" class="ssn-why-needed">
              Why is this needed?
            </a>

            <!-- Passport -->
            <ng-container *ngIf="pageForm.get('officer.ssnOrPassport').value === SsnOrPassport.Passport">
              <mat-form-field appearance="outline" class="passport-form-field">
                <input trim class="lo_sensitive" formControlName="passport" id="txtOfficerPassport" matInput
                  placeholder="e.g 31195855" />
                <mat-error *ngIf="pageForm.get('officer.passport').hasError('required')">
                  Required
                </mat-error>
                <mat-error
                  *ngIf="pageForm.get('officer.passport').hasError('minlength') || pageForm.get('officer.passport').hasError('maxlength')">
                  Please enter a valid passport number.
                </mat-error>
              </mat-form-field>
            </ng-container>

            <p *ngIf="pageForm.get('officer.ssnOrPassport').hasError('pattern')" class="error-message">
              For an officer outside of the US, please select Passport
            </p>
          </div>
        </div>
      </section>

      <!-- Officer Address -->
      <section class="form-section inner-form-section">
        <h3 class="section-title">Officer Address</h3>
        <terra-address-form (formReady)="onOfficerAddressFormReady($event)" [externalForm]="pageForm"
          [formSettings]="addressFormSettings" [locationDetailsResponse]="originalOfficerAddress$ | async"
          class="form-fields address-form" partialFormName="officerAddress" street2Label="Second line of address"
          streetLabel="Street address" />
      </section>

      <!-- Beneficial owners -->
      <section class="form-section">
        <h3 class="section-title beneficial-owner-title">Beneficial Owners</h3>
        <p class="empty-beneficial-owners-message">
          Add all beneficial owners who own more than 25% of the business.
        </p>
      </section>

      <!-- Beneficial owners loader -->
      <ng-template #beneficialOwnersLoader>
        <terra-loader class="loader" />
      </ng-template>

      <!-- Beneficial Owner Details -->
      <ng-container *ngIf="!(isLoadingBeneficialOwners$ | async); else beneficialOwnersLoader"
        formArrayName="beneficialOwners">
        <!-- Single beneficial owner -->
        <ng-container *ngFor="let beneficialOwner of beneficialOwnersFormArray.controls; index as i"
          [formGroup]="beneficialOwner">

          <!-- Beneficial owner basic details  -->
          <section class="form-section beneficial-owner-details">
            <h3 class="section-title beneficial-owner-title">Beneficial Owner Details (#{{ i + 1 }})
              <button (click)="removeBeneficialOwnerAt(i)" class="btn-remove-beneficial-owner cov-button" mat-button
                type="button">
                <mat-icon class="notranslate">person_remove</mat-icon>
                Remove Beneficial Owner
              </button>
            </h3>
            <div class="form-fields">

              <!-- First name -->
              <div class="terra-form-field-wrapper small-field">
                <label [for]="beneficialOwnerFirstNameInput.id" class="text-input-label">First Name</label>
                <mat-form-field appearance="outline">
                  <input trim #beneficialOwnerFirstNameInput [id]="'txtBeneficialOwnerFirstName_' + i"
                    class="lo_sensitive" formControlName="firstName" matInput placeholder="e.g John" />
                  <mat-error *ngIf="beneficialOwner.get('firstName').hasError('required')">
                    Required
                  </mat-error>
                  <mat-error *ngIf="beneficialOwner.get('firstName').getError('maxlength') as error">
                    Please enter up to {{ error.requiredLength }} characters
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Last name -->
              <div class="terra-form-field-wrapper small-field">
                <label [for]="beneficialOwnerLastNameInput.id" class="text-input-label">Last Name</label>
                <mat-form-field appearance="outline">
                  <input trim #beneficialOwnerLastNameInput [id]="'txtBeneficialOwnerLastName_' + i"
                    class="lo_sensitive" formControlName="lastName" matInput placeholder="e.g Smith" />
                  <mat-error *ngIf="beneficialOwner.get('lastName').hasError('required')">
                    Required
                  </mat-error>
                  <mat-error *ngIf="beneficialOwner.get('lastName').getError('maxlength') as error">
                    Please enter up to {{ error.requiredLength }} characters
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Date of birth -->
              <div class="terra-form-field-wrapper">
                <terra-custom-utc-date-picker [id]="'txtBeneficialOwnerDob_'+ i" formControlName="dateOfBirth"
                  label="Date of Birth" [minDate]="MIN_DATE" [maxDate]="today"
                  [requiredError]="beneficialOwner.get('dateOfBirth').hasError('required')"
                  [touched]="beneficialOwner.get('dateOfBirth').touched"
                  [minError]="beneficialOwner.get('dateOfBirth').hasError('minDate')"
                  [maxError]="beneficialOwner.get('dateOfBirth').hasError('maxDate')"
                  maxErrorTxt="Please enter a valid date" minErrorTxt="Please enter a valid date" startAt="1980-01-01"
                  startView="multi-year" />
              </div>

              <!-- Percentage of Ownership -->
              <div class="terra-form-field-wrapper small-field">
                <label [for]="beneficialOwnerPercentage.id" class="text-input-label">Percentage of Ownership</label>
                <mat-form-field appearance="outline">
                  <input trim #beneficialOwnerPercentage [id]="'txtBeneficialOwnerPercentage_' + i"
                    formControlName="percentage" matInput placeholder="e.g 25" terraFormattedNumber type="tel" />
                  <span matSuffix>%</span>
                  <mat-error *ngIf="beneficialOwner.get('percentage')?.hasError('required')">
                    Required
                  </mat-error>
                  <mat-error *ngIf="beneficialOwner.get('percentage')?.getError('min') as error">
                    The minimum allowed ownership percentage is {{ error.min }}%
                  </mat-error>
                  <mat-error *ngIf="beneficialOwner.get('percentage')?.getError('max') as error">
                    The maximum allowed ownership percentage is {{ error.max }}%
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Phone number -->
              <terra-phone class="terra-form-field-wrapper small-field" formControlName="phone">
                <label class="text-input-label">Phone</label>
                <mat-error *ngIf="beneficialOwner.get('phone').hasError('required')">Required</mat-error>
                <mat-error *ngIf="beneficialOwner.get('phone').hasError('phone')">Invalid phone number</mat-error>
              </terra-phone>

              <!-- email -->
              <div class="terra-form-field-wrapper small-field">
                <label [for]="beneficialOwnerEmailInput.id" class="text-input-label">Email</label>
                <mat-form-field appearance="outline">
                  <input trim #beneficialOwnerEmailInput [id]="'txtBeneficialOwnerEmail_' + i" class="lo_sensitive"
                    formControlName="email" matInput placeholder="e.g john@gmail.com" />
                  <mat-error *ngIf="beneficialOwner.get('email').hasError('required')">
                    Required
                  </mat-error>
                  <mat-error *ngIf="beneficialOwner.get('email').hasError('email')">
                    Please enter a valid email address
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Nationality Country -->
              <div class="terra-form-field-wrapper small-field">
                <label class="text-input-label" for="ddNationalityBeneficiary_{{i}}">Nationality</label>
                <mat-form-field appearance="outline" class="nationality-form-field" id="ddNationalityBeneficiary_{{i}}">
                  <terra-country-input formControlName="nationality" placeholder="Select nationality" />
                  <mat-error *ngIf="beneficialOwner.get('nationality').hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="more-details-income terra-form-field-wrapper"
                *ngIf="!isUnitedStateNationality(beneficialOwner)">
                <!-- Occupation -->
                <div class="small-field">
                  <label class="text-input-label" for="ddOccupation">Occupation</label>
                  <mat-form-field appearance="outline" class="nationality-form-field" id="ddOccupation">
                    <mat-select formControlName="occupation" placeholder="Select" [hideSingleSelectionIndicator]="true">
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let item of allOccupation" [value]="item"> {{
                        item | enumString:UnitOccupation
                        }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="beneficialOwner.get('occupation').hasError('required')">
                      Required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Annual Income -->
                <div class="">
                  <label class="text-input-label" for="ddAnnualIncome">Annual Income</label>
                  <mat-form-field appearance="outline" class="nationality-form-field" id="ddAnnualIncome">
                    <mat-select formControlName="annualIncome" placeholder="Select"
                      [hideSingleSelectionIndicator]="true">
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let item of allRevenue" [value]="item"> {{ item | enumString:UnitRevenue }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="beneficialOwner.get('annualIncome').hasError('required')">
                      Required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Primary Source of Income -->
                <div class="small-field">
                  <label class="text-input-label" for="ddSourceOfIncome">Primary Source of Income</label>
                  <mat-form-field appearance="outline" class="nationality-form-field" id="ddSourceOfIncome">
                    <mat-select formControlName="sourceOfIncome" placeholder="Select"
                      [hideSingleSelectionIndicator]="true">
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let item of allSourceOfIncome" [value]="item"> {{
                        item |
                        enumString:UnitSourceOfIncome
                        }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="beneficialOwner.get('sourceOfIncome').hasError('required')">
                      Required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <label class="identification-number">Identification Number:</label>
              <div class="identification-number-form">
                <mat-radio-group aria-labelledby="Identification number"
                  class="radio-buttons-group radio-group-new-primary-color" formControlName="ssnOrPassport">
                  <mat-radio-button [disabled]="disableSsnRadio(beneficialOwner.get('nationality'), beneficialOwner)"
                    [value]="SsnOrPassport.SSN" class="ssn-radio-button">
                    SSN
                  </mat-radio-button>
                  <mat-radio-button
                    [disabled]="disablePassportRadio(beneficialOwner.get('nationality'), beneficialOwner)"
                    [value]="SsnOrPassport.Passport" class="passport-radio-button"
                    [matTooltipDisabled]="!disablePassportRadio(beneficialOwner.get('nationality'), beneficialOwner)"
                    matTooltipClass="team-tooltip" matTooltipPosition="right"
                    matTooltip="{{generateUsCitizenshipTooltipMessage()}}">
                    Passport Number
                  </mat-radio-button>
                </mat-radio-group>

                <!-- SSN -->
                <mat-form-field *ngIf="beneficialOwner.get('ssnOrPassport').value === SsnOrPassport.SSN"
                  appearance="outline" class="ssn-form-field">
                  <input trim #beneficialOwnerSsnInput [id]="'txtBeneficialOwnerSsn_' + i" class="lo_sensitive"
                    formControlName="ssn" matInput placeholder="e.g 123456789" />
                  <mat-error *ngIf="beneficialOwner.get('ssn').hasError('required')">
                    Required
                  </mat-error>
                  <mat-error *ngIf="beneficialOwner.get('ssn').hasError('pattern')">
                    Please enter a valid social security number (SSN)
                  </mat-error>
                </mat-form-field>

                <a href="https://help.covercy.com/why-is-social-security-number-ssn-or-equivalent-required"
                  target="_blank" *ngIf="beneficialOwner.get('ssnOrPassport').value === SsnOrPassport.SSN"
                  class="ssn-why-needed">
                  Why is this needed?
                </a>

                <!-- Passport -->
                <ng-container *ngIf="beneficialOwner.get('ssnOrPassport').value === SsnOrPassport.Passport">
                  <mat-form-field appearance="outline" class="passport-form-field">
                    <input trim #beneficialOwnerPassportInput [id]="'txtBeneficialOwnerPassport_' + i"
                      class="lo_sensitive" formControlName="passport" matInput placeholder="e.g 31195855" />
                    <mat-error *ngIf="beneficialOwner.get('passport').hasError('required')">
                      Required
                    </mat-error>
                    <mat-error
                      *ngIf="beneficialOwner.get('passport').hasError('minlength') || beneficialOwner.get('passport').hasError('maxlength')">
                      Please enter a valid passport number
                    </mat-error>
                  </mat-form-field>
                </ng-container>

                <p *ngIf="beneficialOwner.get('ssnOrPassport').hasError('pattern')" class="error-message">
                  For a beneficial owner outside of the US, please select passport
                </p>
              </div>
            </div>
          </section>

          <!-- Beneficial owner address -->
          <section
            *ngIf="{id: beneficialOwner?.get('id')?.value ? +beneficialOwner?.get('id')?.value : null} as beneficialOwnerData"
            class="form-section inner-form-section">
            <h3 class="section-title beneficial-owner-title">Beneficial Owner #{{ i + 1 }} Address</h3>
            <terra-address-form (formReady)="onBeneficialOwnerAddressFormReady($event)" [externalForm]="beneficialOwner"
              [formSettings]="addressFormSettings"
              [locationDetailsResponse]="(beneficialOwnerAddressesPerOwner$ | async).get(beneficialOwnerData.id) || beneficialOwner.get('address')?.value"
              class="form-fields address-form" partialFormName="address" street2Label="Second line of address"
              streetLabel="Street address" />
          </section>
        </ng-container>


        <button (click)="addBeneficialOwner()" *ngIf="beneficialOwnersFormArray.controls.length <= 100"
          class="btn-add-beneficial-owner cov-button" mat-button type="button">
          <mat-icon class="notranslate">person_add</mat-icon>
          Add Another Beneficial Owner
        </button>
      </ng-container>

      <!-- Additional Business Information -->
      <section class="form-section additional-business-information" *ngIf="showAdditionalBusinessInformation$ | async">
        <h3 class="section-title">Additional Business Information</h3>
        <div class="form-fields">
          <!-- Annual Revenue -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="ddAnnualRevenue">Annual Revenue</label>
            <mat-form-field appearance="outline" class="nationality-form-field" id="ddAnnualRevenue">
              <mat-select formControlName="annualRevenue" placeholder="Select" [hideSingleSelectionIndicator]="true">
                <mat-option>Select</mat-option>
                <mat-option *ngFor="let item of allBusinessRevenue" [value]="item"> {{
                  item |
                  enumString:UnitBusinessAnnualRevenue
                  }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="pageForm.get('annualRevenue').hasError('required')">
                Required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Number of Employees -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="ddNumberOfEmployees">Number of Employees</label>
            <mat-form-field appearance="outline" class="nationality-form-field" id="ddNumberOfEmployees">
              <mat-select formControlName="numberOfEmployees" placeholder="Select"
                [hideSingleSelectionIndicator]="true">
                <mat-option>Select</mat-option>
                <mat-option *ngFor="let item of allNumberOfEmployees" [value]="item"> {{
                  item |
                  enumString:UnitNumberOfEmployees
                  }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="pageForm.get('numberOfEmployees').hasError('required')">
                Required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Countries of operation -->
          <div class="terra-form-field-wrapper small-field">
            <label class="text-input-label" for="ddCountriesOfOperation">Countries of operation</label>
            <mat-form-field appearance="outline" class="nationality-form-field" id="ddCountriesOfOperation">
              <mat-select formControlName="countriesOfOperation" placeholder="Select" multiple>
                <mat-select-trigger>
                  {{ pageForm.get('countriesOfOperation').value?.[0] || '' }}
                  <span *ngIf="(pageForm.get('countriesOfOperation').value?.length || 0) > 1">
                    (+{{ (pageForm.get('countriesOfOperation').value?.length || 0) - 1 }} {{
                    pageForm.get('countriesOfOperation').value?.length === 2 ? 'other' : 'others' }})
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor="let item of allCountriesOfOperation" [value]="item.code"> {{ item.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="pageForm.get('countriesOfOperation').hasError('required')">
                Required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Cash Flow -->
          <div class="small-field cash-flow-radio-btn">
            <label class="text-input-label" for="ddCashFlow">Cash Flow</label>
            <!-- <mat-form-field appearance="outline" class="nationality-form-field"   > -->
            <mat-radio-group aria-label="Select an option" formControlName="cashFlow" id="ddCashFlow" color="primary">
              <mat-radio-button value="Unpredictable">I'm a new company / my cash flow fluctuates</mat-radio-button>
              <mat-radio-button value="Predictable">I'm an established company with predictable cash
                flows</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="pageForm.get('cashFlow').hasError('required')">
              Required
            </mat-error>
            <!-- </mat-form-field> -->
          </div>
        </div>
      </section>
    </div>


    <section class="form-footer">
      <section [hidden]="formContext.processingSubmit" class="agreements-section">
        <h4>Check these to indicate that you have read and agree to the following:</h4>
        <div class="agreements-section-checkbox">
          <mat-checkbox color="primary" formControlName="approveInformation">
            By providing the information above, I hereby certify, to the best of my knowledge, that the information
            provided above is complete and correct.
          </mat-checkbox>
          <mat-error *ngIf="pageForm.get('approveInformation').hasError('required') && (isSubmitAttempt$ | async)"
            class="error-message">
            Please approve the supplied details
          </mat-error>
        </div>
        <p>
          <mat-checkbox color="primary" formControlName="termsOfServiceAgreement">
            I have read and accepted the
            <a href="{{termType.getUrl(termType.ElectronicDisclosureAndConsent)}}" target="_blank">{{
              termType.toString(termType.ElectronicDisclosureAndConsent) }}</a>,
            <a *ngIf="(unitAccountThreadProvider$ | async); else choiceTerms"
              href="{{termType.getUrl(termType.ThreadAccountTermsAndConditions)}}" target="_blank">{{
              termType.toString(termType.ThreadAccountTermsAndConditions) }}</a>,
            <ng-template #choiceTerms>
              <a href="{{termType.getUrl(termType.DepositAccountTermsAndConditions)}}" target="_blank">{{
                termType.toString(termType.DepositAccountTermsAndConditions) }}</a>,
            </ng-template>
            <a href="{{termType.getUrl(termType.ClientPrivacyPolicy)}}" target="_blank">{{
              termType.toString(termType.ClientPrivacyPolicy) }}</a>,
            <br />
            <a href="{{termType.getUrl(termType.ClientTermsOfService)}}" target="_blank">{{
              termType.toString(termType.ClientTermsOfService) }}</a>,
            and I consent to the use of electronic records in connection with this application.
          </mat-checkbox>
          <mat-error *ngIf="pageForm.get('termsOfServiceAgreement').hasError('required') && (isSubmitAttempt$ | async)"
            class="error-message">
            Please accept the above terms
          </mat-error>
        </p>
      </section>

      <!-- Error message -->
      <div *ngIf="formContext.isSubmitAttempt" class="error-section">
        <p *ngIf="pageForm.invalid" class="error-message">
          Please review and correct the fields marked in red
        </p>
        <p *ngIf="formContext.isGeneralServerError" class="error-message">
          {{ generalServerErrorMessage }}
        </p>
        <p *ngIf="formContext.hasServerErrorMessage" class="error-message">
          {{ serverErrorMessage }}
        </p>
      </div>

      <section class="actions">
        <button (click)="startApplicationCreate()" [disabled]="formContext.processingSubmit"
          class="cov-button send-application-button" color="primary" form="applicationForm" mat-flat-button
          type="button">
          Send Application
        </button>
        <button (click)="saveDraft()" [disabled]="formContext.processingSubmit" class="save-draft-button cov-button"
          color="primary" mat-stroked-button type="button">
          Save Draft
        </button>
        <button *ngIf="!formContext.processingSubmit" (click)="cancel()" class="cancel-button cov-button" type="button"
          mat-stroked-button>
          Cancel
        </button>
      </section>
    </section>
  </form>
  <terra-unit-bank-sticky-footer [bankingProviderString]="bankingProviderString" [accountProvider]="bankingProvider" />
</ng-container>
